(function(root){
  'use strict';
  const keys=['kcal','proteinG','fiberG'];
  const validNumber=value=>typeof value==='number'&&Number.isFinite(value)&&value>=0;
  const portionDefinitions=[{quantity:.25,grams:50,multiplier:.5,labelEn:'Small',labelZh:'小份'},{quantity:.5,grams:100,multiplier:.8,labelEn:'Half',labelZh:'半份'},{quantity:1,grams:200,multiplier:1,labelEn:'Regular',labelZh:'正常'},{quantity:1.25,grams:250,multiplier:1.5,labelEn:'Large',labelZh:'加大'}];
  function staplePortions(food){return portionDefinitions.map(p=>({...p,price:Math.round(food.price*p.multiplier*100)/100}))}
  function itemPrice(food,quantity){
    if(!validNumber(food.price))throw new Error('Invalid menu price: '+food.id);
    if(food.cat==='staple'){
      const portion=staplePortions(food).find(p=>p.quantity===quantity);
      if(!portion)throw new Error('Unsupported base portion: '+quantity);
      return portion.price;
    }
    return Math.round(food.price*quantity*100)/100;
  }
  function nutritionFor(food,quantity){
    const data=food.nutrition||{};
    const supported=['estimated','ai_estimate','verified'].includes(data.status)&&typeof data.source==='string'&&data.source.trim().length>0;
    let factor=null;
    if(supported&&data.basis==='per_serving')factor=quantity;
    if(supported&&data.basis==='per_100g'&&validNumber(data.servingGrams)&&data.servingGrams>0)factor=data.servingGrams*quantity/100;
    return Object.fromEntries(keys.map(key=>[key,factor!==null&&validNumber(data[key])?data[key]*factor:null]));
  }
  function calculate(items,foods,packagingFee){
    const rows=Object.entries(items).filter(([,q])=>validNumber(q)&&q>0).map(([id,quantity])=>{
      const food=foods.find(item=>item.id===id);
      if(!food)throw new Error('Unknown menu item: '+id);
      const linePrice=itemPrice(food,quantity);
      return {id,food,quantity,unitPrice:food.cat==='staple'?linePrice:food.price,linePrice,nutrition:nutritionFor(food,quantity)};
    });
    const packaging=rows.length?(validNumber(packagingFee)?packagingFee:0):0;
    const price=Math.round((packaging+rows.reduce((sum,row)=>sum+row.linePrice,0))*100)/100;
    const nutrients=Object.fromEntries(keys.map(key=>{
      const known=rows.filter(row=>row.nutrition[key]!==null);
      return [key,{value:known.length?known.reduce((sum,row)=>sum+row.nutrition[key],0):null,known:known.length,total:rows.length,complete:rows.length>0&&known.length===rows.length}];
    }));
    return {rows,packaging,price,nutrients,complete:rows.length>0&&keys.every(key=>nutrients[key].complete),hasAnyNutrition:keys.some(key=>nutrients[key].known>0)};
  }
  root.MAFE_CBD_CALCULATOR={calculate,nutritionFor,itemPrice,staplePortions};
})(typeof window==='undefined'?globalThis:window);
